<template lang="pug">
div
  v-card(v-if="edit")
    v-card-title {{ edit.ticketart || 'Bestellung' }} {{ edit.id }}
    v-card-text.pt-0
      v-autocomplete(label="Auftraggeber" v-model="edit.userId" :items="[edit.user]" item-text="vollerName" item-value="id" disabled)
      v-layout
        v-flex(xs12 sm6): v-select(label="Status" v-model="edit.status" :items="statusOptions" disabled)
        v-flex(xs12 sm6): v-checkbox(label="Freigegeben" v-model="edit.freigabe" disabled)
      v-data-table(:items="edit.artikelBestellungen" :headers="headersDetails")
        template(slot="items" slot-scope="{ item }")
          td
            template(v-if="item.artikel.anzahlen" single)
              v-select(v-model="item.anzahl" :items="[item.anzahl || 0].concat(item.artikel.anzahlen.map(([anz,pr]) => anz))" clearable :disabled="disabled")
            template(v-else)
              v-text-field(v-model.number="item.anzahl" single :disabled="disabled")
          td
            template(v-if="item.artikel.anzahlen") {{formatEur(preisForArtikelanzahl(item))}}
            template(v-else) {{isFinite(item.anzahl) && `× ${formatEur(item.artikel.preis)} = ${formatEur(item.anzahl * item.artikel.preis)}`}}
          td {{item.artikel.name}}

    v-card-actions
      template(v-if="edit.freigabe")
        v-btn(outline disabled) Ist Bereits Freigegeben
      template(v-else-if="edit.status === 'neu'")
        v-btn(@click="save(true)" color="primary" outline :loading="freigeben === true && loading > 0" :disabled="freigeben === false") Freigeben
        v-btn(@click="save(false)" color="error" outline :loading="freigeben === false && loading > 0" :disabled="freigeben === true") Freigabe Verweigern
      template(v-else)
        v-btn(outline disabled) Bestellung ist {{edit.statusHuman}}
  v-card(v-else-if="edit === false || !$route.query.token")
    v-card-text
      v-alert(:value="true" type="error") Konnte nicht gefunden werden.
</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      edit: null,
      loading: 0,
      freigeben: null,
      itTicketVorgangs: [],
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Abgebrochen', value: 'abgebrochen' },
      ],
      headersDetails: [
        { text: 'Anzahl', sortable: false },
        { text: 'Preis', sortable: false },
        { text: 'Artikel', sortable: false },
      ]
    }
  },
  apollo: {
    itTicketVorgangs: {
      query: gql`query ExtraItTicketVorgaengeBearbeitenVueItTicketVorgangs(
        $token: String
      ) {
        itTicketVorgangs(where: {
          custom: { p: "freigabe_token", v: $token }
        }) {
          id
          prioritaet
          ticketart
          level
          summe
          status
          statusHuman
          freigabe
          itTicket {
            id
            person {
              id
              vollerName
            }
          }
          user {
            id
            vollerName
          }
          artikelBestellungen {
            id
            anzahl
            bearbeitet
            artikel {
              id
              name
              preis
              art
              anzahlen
            }
          }
        }
      }`,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          token: this.$route.query.token,
        }
      },
      skip() {
        return !this.$route.query.token
      }
    }
  },
  watch: {
    itTicketVorgangs(vorgaenge) {
      const vorgang = vorgaenge && vorgaenge[0]
      this.edit = vorgang && { ...vorgang, artikelBestellungen: vorgang.artikelBestellungen.map(bestellung => {
        return {
          id: bestellung.id,
          bearbeitet: bestellung.bearbeitet || false,
          anzahl: bestellung.anzahl,
          artikel: bestellung.artikel
        }
      }) } || false
    }
  },
  computed: {
    disabled() {
      return !this.edit || this.edit.freigabe || this.edit.status !== 'neu'
    }
  },
  methods: {
    formatEur(value) {
      if (isFinite(value) && !isNaN(value)) {
        return `${(Math.round(value*100)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`
      } else {
        return ''
      }
    },
    preisForArtikelanzahl(bestellung) {
      const artikel = bestellung.artikel
      const anzahl = artikel.anzahlen.find(([anz, preis]) => bestellung.anzahl === anz)
      if (anzahl) {
        const preis = anzahl[1]
        return preis === 0 ? preis : preis || artikel.preis
      } else {
        return artikel.preis
      }
    },
    save(freigeben) {
      this.freigeben = freigeben
      this.loading++
      this.gqlClearAllErrors()
      const edit = this.edit
      let freigabe = edit.freigabe
      let status = edit.status
      if (freigeben) {
        freigabe = true
      } else {
        status = 'abgebrochen'
      }
      this.$apollo.mutate({
        mutation: gql`mutation (
            $id: ID,
            $status: String
            $freigabe: Boolean
            $artikelBestellungen: [ItAuftraegeUpdateInput]
        ) {
          itTicketVorgangUpdate(
            id: $id
            status: $status
            freigabe: $freigabe
            artikelBestellungen: $artikelBestellungen
          ) {
            id
            status
            freigabe
          }
        }`,
        variables: {
          id: edit.id,
          status: status,
          freigabe: freigabe,
          artikelBestellungen: edit.artikelBestellungen.map(b => ({ ...b, anzahl: `${b.anzahl || 0}`, artikelId: b.artikel.id, artikel: undefined }))
        },
      }).then((data) => {
        this.freigeben = null
        this.loading--
      }, (error) => {
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
        this.freigeben = null
        this.loading--
      })
    }
  }
}
</script>
